/* eslint-disable */

import React, { useState, useEffect } from 'react';
import { HiMenuAlt4, HiX } from 'react-icons/hi';
import { BsLinkedin, BsGithub } from 'react-icons/bs';
import { motion, AnimatePresence } from 'framer-motion';
import './Navbar.scss';

const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (toggle) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [toggle]);

  const menuItems = ['home', 'work', 'experience', 'tech', 'contact'];

  const handleMenuItemClick = () => {
    setToggle(false);
  };

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <a href="#home">V</a>
      </div>

      {/* Desktop Navigation Links */}
      <ul className="app__navbar-links">
        {menuItems.map((item) => (
          <li className="app__flex p-text" key={`link-${item}`}>
            <div />
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
      </ul>

      {/* Desktop Social Icons */}
      <div className="app__navbar-social">
        <div onClick={() => window.open('https://www.linkedin.com/in/varanbhalla', '_blank')}>
          <BsLinkedin />
        </div>
        <div onClick={() => window.open('https://github.com/varanbhalla', '_blank')}>
          <BsGithub />
        </div>
      </div>

      {/* Mobile Menu Button */}
      <div className="app__navbar-menu-button">
        <motion.button
          className="hamburger-button"
          onClick={() => setToggle(true)}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          aria-label="Open menu"
        >
          <HiMenuAlt4 />
        </motion.button>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence mode="wait">
        {toggle && (
          <>
            {/* Backdrop */}
            <motion.div
              className="mobile-menu-backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.25 }}
              onClick={() => setToggle(false)}
            />

            {/* Mobile Menu Panel */}
            <motion.div
              className="mobile-menu-panel"
              initial={{ x: '100%' }}
              animate={{ x: 0 }}
              exit={{ x: '100%' }}
              transition={{
                type: 'spring',
                stiffness: 300,
                damping: 30
              }}
            >
              {/* Close Button */}
              <motion.button
                className="mobile-menu-close"
                onClick={() => setToggle(false)}
                initial={{ opacity: 0, rotate: -90 }}
                animate={{ opacity: 1, rotate: 0 }}
                exit={{ opacity: 0, rotate: 90 }}
                transition={{ delay: 0.15, duration: 0.2 }}
                whileHover={{ scale: 1.1, rotate: 90 }}
                whileTap={{ scale: 0.9 }}
                aria-label="Close menu"
              >
                <HiX />
              </motion.button>

              {/* Menu Items */}
              <motion.ul
                className="mobile-menu-list"
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={{
                  hidden: { opacity: 0 },
                  visible: {
                    opacity: 1,
                    transition: {
                      staggerChildren: 0.07,
                      delayChildren: 0.15
                    }
                  },
                  exit: {
                    opacity: 0,
                    transition: { duration: 0.15 }
                  }
                }}
              >
                {menuItems.map((item, index) => (
                  <motion.li
                    key={item}
                    variants={{
                      hidden: { x: 30, opacity: 0 },
                      visible: {
                        x: 0,
                        opacity: 1,
                        transition: {
                          type: 'spring',
                          stiffness: 300,
                          damping: 24
                        }
                      },
                      exit: { x: 30, opacity: 0 }
                    }}
                  >
                    <a href={`#${item}`} onClick={handleMenuItemClick}>
                      <motion.span
                        className="menu-number"
                        whileHover={{ scale: 1.1 }}
                      >
                        {String(index + 1).padStart(2, '0')}
                      </motion.span>
                      <motion.span
                        className="menu-text"
                        whileHover={{ x: 5 }}
                      >
                        {item}
                      </motion.span>
                    </a>
                  </motion.li>
                ))}
              </motion.ul>

              {/* Mobile Social Links */}
              <motion.div
                className="mobile-menu-social"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 20 }}
                transition={{ delay: 0.5, duration: 0.3 }}
              >
                <motion.button
                  className="social-icon"
                  onClick={() => window.open('https://www.linkedin.com/in/varanbhalla', '_blank')}
                  whileHover={{ scale: 1.1, y: -3 }}
                  whileTap={{ scale: 0.95 }}
                  aria-label="LinkedIn"
                >
                  <BsLinkedin />
                </motion.button>
                <motion.button
                  className="social-icon"
                  onClick={() => window.open('https://github.com/varanbhalla', '_blank')}
                  whileHover={{ scale: 1.1, y: -3 }}
                  whileTap={{ scale: 0.95 }}
                  aria-label="GitHub"
                >
                  <BsGithub />
                </motion.button>
              </motion.div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
